/**
 * 全局配置文件
 */
 import urlSettings from '@/config/url-settings.js';
// let origin = window.location.hostname;
let wyFlag = false;
if(urlSettings.VUE_APP_PLATFORM == 'hpss'){
  wyFlag = false;
}else{
  wyFlag = true;
}

// if(origin.indexOf('hre')>-1){
//   wyFlag = false;
// }else{
//   wyFlag = true;
// }
// import urlSettings from '@/config/url-settings.js';
export default {
  title: wyFlag?"":"saber",
  logo: "S",
  key: 'saber',//配置主键,目前用于存储
  indexTitle: urlSettings.VUE_APP_HOME_NAME,
  clientId: 'saber', // 客户端id
  clientSecret: 'saber_secret', // 客户端密钥
  tenantMode: false, // 是否开启租户模式
  tenantId: urlSettings.TENANTID, // 管理组租户编号
  captchaMode: urlSettings.LOGIN_CAPTCHA_MODE, // 是否开启验证码模式
  lockPage: '/lock',
  tokenTime: 3000,
  tokenHeader: 'Blade-Auth',
  //http的status默认放行列表
  statusWhiteList: [],
  //配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: "首页",
    value: "/wel/index",
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard'
    },
    group: [],
    close: false
  },
  //配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children'
    }
  },
  // 第三方系统授权地址
  authUrl: 'http://localhost/hpss-auth/oauth/render',
  // 流程设计器地址
  flowDesignUrl: 'http://localhost:9999',
  // 报表设计器地址(cloud端口为8108,boot端口为80)
  reportUrl: 'http://localhost:8108/ureport',
  maxUploadSize:10*1024*1024
}
